import React, { useEffect, useState } from 'react'
import { Form } from 'react-final-form'
import { useReportSalesTradeLiensMutation } from '../../../services'
import { getCurrentDate } from '../../../utils/general'
import { useDispatch, useSelector } from 'react-redux'
import { enqueueNotification } from '../../../redux/slices/notificationsSlice'
import FilteringModal from './components/FilteringModal/FilteringModal'
import Header from './components/Header/Header'
import TradeLiensTableBlock from './components/TradeLiensTableBlock/TradeLiensTableBlock'
import { UspReportTradeLienResult } from '../../../models'
import { convertDateToString } from '../../../utils/dateUtils'
import { useNavigate } from 'react-router-dom'
import { getUserAccessRights } from '../../../redux/slices/authSlice'
import { appRoute } from '../../../constants'
import { Card, Container } from '@mui/material'
import CustomBreadcrumbs from '../../../components/custom-breadcrumbs/custom-breadcrumbs'

const TradeLiens = () => {
  const navigate = useNavigate()
  const userAccess = useSelector(getUserAccessRights)
  const dispatch = useDispatch()
  const [showTable, setShowTable] = useState(false)
  const [openFilterModal, setOpenFilterModal] = useState(true)
  const [formValues, setFormValues] = useState<any>(null)

  const [filterTradeLiens, { data: filterData, isSuccess: filterIsSuccess, isLoading: filterIsLoading }] = useReportSalesTradeLiensMutation()

  const handleOpenFilterModal = () => setOpenFilterModal(true)
  const handleCloseFilterModal = () => setOpenFilterModal(false)

  const handleSubmit = (values: any) => {
    const jsonBranchList = values?.Branch?.map((item: any) => ({ BranchID: item?.BranchID }))

    filterTradeLiens({
      uspReportTradeLien: {
        asOfDate: getCurrentDate(),
        jsonBranchList: jsonBranchList || null,
        startDate: convertDateToString(values.StartDate) || null,
        endDate: convertDateToString(values.EndDate) || null,
        isUnpaid: values.IsUnpaid,
        isBasedOnFinalizedDate: values.IsBased,
      },
    })
    setFormValues(values)
  }

  useEffect(() => {
    if (filterIsSuccess) {
      handleCloseFilterModal()
      setShowTable(true)
      dispatch(enqueueNotification({ message: 'Success' }))
    }
  }, [filterIsSuccess])

  useEffect(() => {
    if (!userAccess.CanAccessSalesInsights) {
      dispatch(
        enqueueNotification({
          message:
            'Access Denied: Sorry, your current access rights do not permit you to enter this section. If you believe you should have access, please contact your system administrator or help desk for assistance.',
          options: { variant: 'error' },
        }),
      )
      navigate(appRoute.Home)
    }
  }, [userAccess, appRoute])

  return (
    <Container
      sx={{
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <CustomBreadcrumbs
        heading='Reports'
        links={[
          {
            href: appRoute.Insights,
            name: 'List',
          },
          {
            name: 'Trade Liens',
          },
        ]}
        sx={{
          mb: {
            xs: 3,
            md: 5,
          },
        }}
      />
      <Card
        sx={{
          height: { xs: 800, md: 2 },
          flexGrow: { md: 1 },
          display: { md: 'flex' },
          flexDirection: { md: 'column' },
        }}
      >
        <Form keepDirtyOnReinitialize onSubmit={handleSubmit} initialValues={{ IsUnpaid: true, IsBased: true }}>
          {({ handleSubmit }: any) => (
            <form onSubmit={handleSubmit}>
              {showTable && <Header handleOpenFilterModal={handleOpenFilterModal} filterData={filterData as UspReportTradeLienResult[]} />}
              <FilteringModal formValues={formValues} open={openFilterModal} handleClose={handleCloseFilterModal} />
              {showTable && <TradeLiensTableBlock filterData={filterData as UspReportTradeLienResult[]} isLoading={filterIsLoading} />}
            </form>
          )}
        </Form>
      </Card>
    </Container>
  )
}

export default TradeLiens
